import React, { useState } from 'react';
import { Button } from '@material-tailwind/react';

function Agreements() {
  const [drafts, setDrafts] = useState([
    { id: 1, name: 'Draft 1', dateSent: '2024-11-01', status: 'Pending', comments: 'Needs review', dateApproved: null },
    { id: 2, name: 'Draft 2', dateSent: '2024-11-02', status: 'Pending', comments: 'Awaiting feedback', dateApproved: null },
  ]);

  const [notifications, setNotifications] = useState([
    { id: 1, name: 'Approved Agreement 1', comments: 'Looks good!', dateApproved: '2024-11-01' },
    { id: 2, name: 'Draft Agreement 1', comments: 'Requires edits', dateApproved: null },
  ]);

  const handleCreateAgreement = () => {
    // Implement the logic to create a new agreement
    console.log('Creating a new agreement...');
  };

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold mb-4">Agreements</h1>
      <Button onClick={handleCreateAgreement} color="blue" className="mb-4">
        Create Agreement
      </Button>

      <div className="mb-8">
        <h2 className="text-lg font-semibold">Draft Agreements</h2>
        <table className="min-w-full border-collapse border border-gray-200">
          <thead>
            <tr>
              <th className="border border-gray-300 p-2">Agreement</th>
              <th className="border border-gray-300 p-2">Date Sent</th>
              <th className="border border-gray-300 p-2">Status</th>
              <th className="border border-gray-300 p-2">Comments</th>
              <th className="border border-gray-300 p-2">Date Approved</th>
            </tr>
          </thead>
          <tbody>
            {drafts.map((draft) => (
              <tr key={draft.id}>
                <td className="border border-gray-300 p-2">{draft.name}</td>
                <td className="border border-gray-300 p-2">{draft.dateSent}</td>
                <td className="border border-gray-300 p-2">{draft.status}</td>
                <td className="border border-gray-300 p-2">{draft.comments}</td>
                <td className="border border-gray-300 p-2">{draft.dateApproved ? draft.dateApproved : 'N/A'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      
    </div>
  );
}

export default Agreements;
